module.exports = {"document":{"nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","leaves":[{"text":""}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fields/components/lib/value.json
// module id = 339
// module chunks = 0